import { cn } from '@/lib/utils'

/**
 * Image Icon SVG Component (Dropdown Style)
 * An emerald image file icon with white image symbol
 * Extracted from dropdown-sources.tsx pattern to match the compact dropdown styling
 */
export function ImageIcon1({ className }: { className?: string }) {
  return (
    <svg
      className={cn('corner-squircle', className)}
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Main document rectangle with rounded corners */}
      <rect x="0" y="0" width="20" height="24" rx="4" fill="#059669" />

      {/* Lighter square highlight in top-right corner */}
      <rect x="14" y="0" width="6" height="6" rx="2" fill="#10B981" />

      {/* Shadow effect */}
      <rect
        x="0"
        y="0"
        width="20"
        height="24"
        rx="4"
        fill="none"
        stroke="rgba(4, 120, 87, 0.3)"
        strokeWidth="1"
      />

      {/* Image icon symbol - simplified mountain/landscape */}
      <g fill="white" opacity="0.9">
        {/* Small circle for sun/point */}
        <circle cx="14" cy="7" r="1.5" />
        {/* Mountain peaks */}
        <path d="M3 18L7 12L11 16L15 10L17 18H3Z" />
      </g>
    </svg>
  )
}
